// extracted by mini-css-extract-plugin
module.exports = {"description":"LandingPage_description__i1_Hj","grid":"LandingPage_grid__KB_6j"};